import React from 'react';
import HeatPumpCalculator from '../components/heatpumpcalculator';

export default function HeatPumpPage() {
  return <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}><HeatPumpCalculator /></div>;
}